import api from './api'
import { ApiResponse } from '../types/api'
import { WorkOrderSummary } from '../types/workOrderSummary'
import { CompanySummary } from '../types/companySummary'

interface PendingParams {
  workshopCompanyId: number
  mechanicId?: number
}

const buildMechanicParams = (params: PendingParams) => {
  const query: Record<string, number> = {}
  if (params.mechanicId) {
    query.mechanicId = params.mechanicId
  }
  return query
}

export const mechanicService = {
  async getPendingWorkOrders(params: PendingParams): Promise<WorkOrderSummary[]> {
    const response = await api.get<ApiResponse<WorkOrderSummary[]>>(
      `/work-orders/workshop/${params.workshopCompanyId}/pending`,
      {
        params: buildMechanicParams(params),
      }
    )
    return response.data.data ?? []
  },

  async getPendingClients(params: PendingParams): Promise<CompanySummary[]> {
    const response = await api.get<ApiResponse<CompanySummary[]>>(
      `/work-orders/workshop/${params.workshopCompanyId}/pending/clients`,
      {
        params: buildMechanicParams(params),
      }
    )
    return response.data.data ?? []
  },

  async getAllClients(params: PendingParams): Promise<CompanySummary[]> {
    const response = await api.get<ApiResponse<CompanySummary[]>>(
      `/companies/workshop/${params.workshopCompanyId}/customers`,
      {
        params: buildMechanicParams(params),
      }
    )
    return response.data.data ?? []
  },
}




